import styled from 'styled-components';

export const ItemOverviewContainer = styled.div`
    width: 25rem;
`;
